function initializeSwiper() {
  let swiperSlideElments = document.querySelectorAll(
    "#product-others .swiper-slide"
  );
  if (!swiperSlideElments[0]) {
    return;
  }
  let recentlySwiper = new Swiper("#product-others .swiper-container", {
    slidesPerView: 1.3,
    slidesPerColumn: 1,
    //spaceBetween: 15,
    breakpoints: {
      768: {
        slidesPerView: 2.5,
      },
      1024: {
        slidesPerView: 4,
        navigation: {
          nextEl: "#product-others .swiper-button-next",
          prevEl: "#product-others .swiper-button-prev",
        },
        on: {
          init: function () {
            if (
              this.slides.length > 0 &&
              this.navigation.prevEl &&
              this.navigation.nextEl
            ) {
              this.navigation.prevEl.style.top =
                this.slides[0].querySelector("img").clientWidth / 2 + "px";
              this.navigation.nextEl.style.top =
                this.slides[0].querySelector("img").clientWidth / 2 + "px";
            }
          },
          resize: function () {
            if (
              this.slides.length > 0 &&
              this.navigation.prevEl &&
              this.navigation.nextEl
            ) {
              this.navigation.prevEl.style.top =
                this.slides[0].querySelector("img").clientWidth / 2 + "px";
              this.navigation.nextEl.style.top =
                this.slides[0].querySelector("img").clientWidth / 2 + "px";
            }
          },
        },
      },
    },
  });
}

document.addEventListener("recentlyViewedProductsLoaded", function () {
  initializeSwiper();
});
